import { Badge } from '@/components/core/Badge';
import { cn } from '@/services/utils';

import { roleBadgePresentation } from '../user-management.format';
import { RoleDefinition } from '../user-management.types';

interface RoleBadgesProps {
    roles: string[];
    roleMetadataByName: Record<string, RoleDefinition>;
}

export function RoleBadges({ roles, roleMetadataByName }: RoleBadgesProps) {
    return (
        <span className="tw-flex tw-flex-wrap tw-gap-1 tw-m-1">
            {roles.map((role) => {
                const presentation = roleBadgePresentation(roleMetadataByName[role]);
                return (
                    <Badge key={role} variant={presentation.variant}>
                        <span className={cn(presentation.italic && 'tw-italic')}>{role}</span>
                    </Badge>
                );
            })}
        </span>
    );
}
